export default __webpack_public_path__ + "static/media/upender.155e03dd.jpeg";